import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as actions from '../../actions/ContactActions'

class Contact extends Component {

    componentDidMount() {
        this.props.getAllContact();
    }

    showAllContact = (contact) => {
        if (contact) {
            return contact.map((item, index) => {
                return (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.name}</td>
                        <td>{item.email}</td>
                        <td>{item.email}</td>
                        <td>{item.comment}</td>
                        <td>
                            <button className="btn btn-outline-info mr-3">Reply</button>
                        </td>
                    </tr>
                )
            })
        }
    }

    render() {
        var { contacts } = this.props;
        return (
            <div className="products__page pt-2 pb-5">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h3 className="account__page--title">Contact</h3>
                        </div>
                        <div className="col-12">
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th>STT</th>
                                        <th>User</th>
                                        <th>Email</th>
                                        <th>Comment</th>
                                        <th>Reply</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.showAllContact(contacts)}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        contacts: state.contact
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getAllContact: () => {
            dispatch(actions.fetchAPIAllContact())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Contact);
